import { render } from "./AppTextElement.vue?vue&type=template&id=50daf6e3&scoped=true"
import script from "./AppTextElement.vue?vue&type=script&lang=js"
export * from "./AppTextElement.vue?vue&type=script&lang=js"

import "./AppTextElement.vue?vue&type=style&index=0&id=50daf6e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50daf6e3"]])

export default __exports__